import React, {Fragment} from 'react'
import { Button } from '@drifthq/tide-core'

import EmailSnippetModal from 'layouts/InstallStep/EmailModal'
import Snippet from 'layouts/Snippet'

import NotificationModal from 'components/NotificationModalExp'

import './style.css'

const InstallJavascript = ({
  snippet,
  onContinueClick,
  inviteModal,
  inviteSucceeded,
  showInviteModal,
  hideInviteModal,
  onInvitedSuccess,
  onDashboardClick
}) => (
  <Fragment>
    <p className="install-exp-javascript-description">
      Paste the code below before the <code className="touchless-install-snippet-code">&lt;/head&gt;</code> tag on every page you want Drift to appear.
    </p>
    <Snippet snippet={snippet} className="install-javascript-snippet"/>
    <p className="install-exp-docs">
      Identify visitors on your site. <a className="touchless-install-snippet-wrapper-a" href="https://help.drift.com/article/install-drift-on-your-website-javascript/" target="_blank" rel="noopener noreferrer">Learn more</a>
    </p>
    { !inviteSucceeded ? <Button className="install-javascript-continue-button" onClick={onContinueClick}>Verify Installation</Button> : <Button onClick={onDashboardClick}>Continue to Dashboard</Button> }
    { !inviteSucceeded && <a className="install-exp-email-modal" onClick={showInviteModal}>Email a teammate for help</a> }
    {inviteModal &&
      <EmailSnippetModal
        onClose={hideInviteModal}
        onSuccess={onInvitedSuccess}
      />
    }
    <NotificationModal showModal={inviteSucceeded} text="Email sent successfully" />
  </Fragment>
)

export default InstallJavascript


// WEBPACK FOOTER //
// ./src/layouts/InstallJavascript/component.js